import { createTheme } from "@mui/material/styles";
import { Colors } from "./utils/colors";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
    background: {
      default: Colors.secondary,
      paper: "#ffffff14",
    },
    text: {
      primary: Colors.text,
    },
  },

  shape: {
    borderRadius: 14,
  },

  typography: {
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: Colors.text,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: Colors.muted,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: Colors.muted,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: Colors.primary,
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: Colors.muted,
          "&.Mui-focused": {
            color: Colors.primary,
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: Colors.primary,
          "&:hover": {
            backgroundColor: Colors.primaryHover || Colors.primary,
          },
        },
        outlined: {
          borderColor: Colors.primary,
          color: Colors.primary,
          "&:hover": {
            borderColor: Colors.primaryHover || Colors.primary,
          },
        },
      },
    },
  },
});

export default theme;
